module.exports = __webpack_public_path__ + "static/media/copy.bcc74501.png";